"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useContext } from "react";
import { AuthContext } from "@/components/auth/Auth";
import PrimaryButton from "@/components/utils/button/PrimaryButton";
import type { ApiWave } from "@/generated/models/ApiWave";
import { useWave } from "@/hooks/useWave";
import { WaveleaderboardSort } from "./WaveleaderboardSort";
import type { WaveDropsLeaderboardSort } from "@/hooks/useWaveDropsLeaderboard";
import { Tooltip } from "react-tooltip";
import { createBreakpoint } from "react-use";
interface WaveLeaderboardHeaderProps {
  readonly wave: ApiWave;
  readonly onCreateDrop: () => void;
  readonly viewMode: "list" | "grid";
  readonly onViewModeChange: (mode: "list" | "grid") => void;
  readonly sort: WaveDropsLeaderboardSort;
  readonly onSortChange: (sort: WaveDropsLeaderboardSort) => void;
}
const useBreakpoint = createBreakpoint({
  MD: 768,
  S: 0
});
export const WaveLeaderboardHeader: React.FC<WaveLeaderboardHeaderProps> = t0 => {
  const $ = _c(18);
  const {
    wave,
    onCreateDrop,
    viewMode: t1,
    onViewModeChange,
    sort,
    onSortChange
  } = t0;
  const viewMode = t1 === undefined ? "list" : t1;
  const {
    connectedProfile
  } = useContext(AuthContext);
  const {
    isMemesWave,
    participation
  } = useWave(wave);
  const breakpoint = useBreakpoint();
  let t2;
  if ($[0] !== breakpoint || $[1] !== isMemesWave || $[2] !== onSortChange || $[3] !== onViewModeChange || $[4] !== sort || $[5] !== viewMode || $[6] !== wave) {
    t2 = isMemesWave && <div className="tw-flex tw-items-center tw-gap-x-2">{breakpoint === "MD" && <div className="tw-flex tw-items-center tw-gap-2"><><button className={`tw-h-9 tw-w-9 tw-flex tw-items-center tw-justify-center tw-border tw-border-solid tw-rounded-lg tw-transition-colors ${viewMode === "list" ? "tw-bg-primary-600/20 tw-border-primary-500/50 tw-text-primary-400" : "tw-bg-iron-950 tw-border-white/10 tw-text-iron-300 desktop-hover:hover:tw-bg-white/10"}`} onClick={() => onViewModeChange("list")} data-tooltip-id={`list-view-${wave.id}`}><svg xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="tw-size-5 tw-flex-shrink-0"><path strokeLinecap="round" strokeLinejoin="round" d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" /></svg></button><Tooltip id={`list-view-${wave.id}`} place="top" offset={8} opacity={1} style={{
            padding: "4px 8px",
            background: "#37373E",
            color: "white",
            fontSize: "13px",
            fontWeight: 500,
            borderRadius: "6px",
            boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
            zIndex: 99999,
            pointerEvents: "none"
          }}>List view</Tooltip></><><button className={`tw-h-9 tw-w-9 tw-flex tw-items-center tw-justify-center tw-border tw-border-solid tw-rounded-lg tw-transition-colors ${viewMode === "grid" ? "tw-bg-primary-600/20 tw-border-primary-500/50 tw-text-primary-400" : "tw-bg-iron-950 tw-border-white/10 tw-text-iron-300 desktop-hover:hover:tw-bg-white/10"}`} onClick={() => onViewModeChange("grid")} data-tooltip-id={`grid-view-${wave.id}`}><svg xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="tw-size-5 tw-flex-shrink-0"><path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6A2.25 2.25 0 0 1 6 3.75h2.25A2.25 2.25 0 0 1 10.5 6v2.25a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25V6ZM3.75 15.75A2.25 2.25 0 0 1 6 13.5h2.25a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25H6A2.25 2.25 0 0 1 3.75 18v-2.25ZM13.5 6a2.25 2.25 0 0 1 2.25-2.25H18A2.25 2.25 0 0 1 20.25 6v2.25A2.25 2.25 0 0 1 18 10.5h-2.25a2.25 2.25 0 0 1-2.25-2.25V6ZM13.5 15.75a2.25 2.25 0 0 1 2.25-2.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-2.25A2.25 2.25 0 0 1 13.5 18v-2.25Z" /></svg></button><Tooltip id={`grid-view-${wave.id}`} place="top" offset={8} opacity={1} style={{
            padding: "4px 8px",
            background: "#37373E",
            color: "white",
            fontSize: "13px",
            fontWeight: 500,
            borderRadius: "6px",
            boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
            zIndex: 99999,
            pointerEvents: "none"
          }}>Grid view</Tooltip></></div>}<WaveleaderboardSort sort={sort} onSortChange={onSortChange} waveId={wave.id} /></div>;
    $[0] = breakpoint;
    $[1] = isMemesWave;
    $[2] = onSortChange;
    $[3] = onViewModeChange;
    $[4] = sort;
    $[5] = viewMode;
    $[6] = wave;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t2) {
    t3 = <div className="tw-mb-2 tw-flex tw-items-center tw-gap-x-2 lg:tw-gap-x-4">{t2}</div>;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== connectedProfile || $[11] !== isMemesWave || $[12] !== onCreateDrop || $[13] !== participation) {
    t4 = connectedProfile && participation.isEligible && <div className={`tw-w-auto tw-mb-4  ${isMemesWave ? "tw-ml-auto lg:tw-hidden" : ""}`}><PrimaryButton loading={false} disabled={false} onClicked={onCreateDrop} padding="tw-px-3 tw-py-2"><svg className="tw-w-4 tw-h-4 tw-flex-shrink-0 -tw-ml-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path fillRule="evenodd" d="M12 3.75a.75.75 0 01.75.75v6.75h6.75a.75.75 0 010 1.5h-6.75v6.75a.75.75 0 01-1.5 0v-6.75H4.5a.75.75 0 010-1.5h6.75V4.5a.75.75 0 01.75-.75z" clipRule="evenodd" /></svg><span>Drop</span></PrimaryButton></div>;
    $[10] = connectedProfile;
    $[11] = isMemesWave;
    $[12] = onCreateDrop;
    $[13] = participation;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t3 || $[16] !== t4) {
    t5 = <div className="tw-flex tw-flex-col tw-gap-y-4 tw-@container tw-bg-black tw-pt-2"><div className="tw-flex tw-items-center tw-gap-2 tw-overflow-x-auto">{t3}{t4}</div></div>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
};